(() => {
  let refreshPromise = null;

  async function refreshDrawer() {
    if (refreshPromise) return refreshPromise;

    refreshPromise = (async () => {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', 'cart-drawer-section');

        const response = await fetch(url.toString(), {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) return false;

        const sections = await response.json();
        const html = sections && sections['cart-drawer-section'];
        if (!html) return false;

        const current = document.getElementById('shopify-section-cart-drawer-section');
        if (!current) return false;

        const template = document.createElement('template');
        template.innerHTML = String(html).trim();

        const incoming = template.content.querySelector('#shopify-section-cart-drawer-section');
        if (incoming) current.replaceWith(incoming);
        else current.innerHTML = String(html);

        return true;
      } catch (error) {
        console.warn('[Stressbollen cart drawer] Kunde inte uppdatera drawer.', error);
        return false;
      } finally {
        refreshPromise = null;
      }
    })();

    return refreshPromise;
  }

  async function openDrawer(options = {}) {
    if (options.refresh !== false) await refreshDrawer();

    try {
      await customElements.whenDefined('theme-drawer');
    } catch (error) {}

    const drawer = document.getElementById('cart-drawer');
    if (!drawer) {
      window.location.href = '/cart';
      return;
    }

    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    const dialog = drawer.querySelector('dialog');
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    }
  }

  document.addEventListener('cart:refresh', () => {
    refreshDrawer();
  });

  document.addEventListener('cart:open', event => {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    openDrawer({ refresh: true });
  });

  window.StressbollenCartDrawer = {
    open: openDrawer,
    refresh: refreshDrawer
  };
})();